import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  mode: "history",
  routes: [
    {
      path: "/bcksorhsd", // 意见反馈
      name: "bcksorhsd",
      meta: {
        title: "Masukan",
      },
      component: () => import("@/views/bcksorhsd/index.vue"),
    },
    {
      path: "/paywdjr", // H5选择支付
      name: "paywdjr",
      meta: {
        title: "Pilih metode pembayaran",
      },
      component: () => import("@/views/paywdjr/index.vue"),
    },
    {
      path: "/nvveiahd", // 隐私协议
      name: "nvveiahd",
      meta: {
        title: "Kebijakan Privasi",
      },
      component: () => import("@/views/nvveiahd/index.vue"),
    },
    {
      path: "/abcisadf", // 关于我们
      name: "abcisadf",
      meta: {
        title: "Tentang kami",
      },
      component: () => import("@/views/abcisadf/index.vue"),
    },
    {
      path: "/dRxcjh", //贷款合同
      name: "DRxcjh",
      meta: {
        title: "Kontrak Pinjaman",
      },
      component: () => import("@/views/dRxcjh/index.vue"),
    },
    {
      path: "/fdidsad", //apk下载链接
      name: "fdidsad",
      component: () => import("@/views/fdidsad/index.vue"),
    },
    {
      path: "/lastbv", //apk下载链接
      name: "lastbv",
      component: () => import("@/views/lastbv/index.vue"),
    },
  ],
});

export default router;
